;(function($) {

	// *************************************************************************
	// Default options
	// *************************************************************************

	var defaultOptions = {
		delay: 5000,
	};

	// *************************************************************************
	// Class declaration
	// *************************************************************************

	function Curtain(element, options) {
		this.$element = $(element);
		this.options = options;

		this.slides = this.$element.children();
		this.slidesCount = this.slides.length;
		this.activeSlide = 0;
	}
	Curtain.prototype = {
		constructor: Curtain,

		ready: function() {
			// Do, only if there are some slides
			if (this.slidesCount <= 0) { return; }

			setInterval(this.onTick.bind(this), this.options.delay);
		},

		onTick: function() {
			var nextSlide = (this.activeSlide + 1) % this.slidesCount;
			var $currentItem = $(this.slides[this.activeSlide]);
			var $nextItem = $(this.slides[nextSlide]);

			$nextItem.addClass("active");
			$currentItem.removeClass("active");

			this.activeSlide = nextSlide;
		},

	};


	// *************************************************************************
	// jQuery plugin
	// *************************************************************************

	$.fn.curtain = function(options) {
		return $(this).each(function () {
			var opts = $.extend({}, options, defaultOptions);
			var curtain = new Curtain(this, opts);
			curtain.ready();
		});
	}

}(jQuery));